import { getValidBids } from "./bidding";
import { getValidCards } from "./play";
/**
 * Batak's own clocks. Bidding takes longer than playing a card, and which step
 * takes how long is game knowledge; the shell only asks `pacing`.
 * Defaults follow review 0004 S6 (30 s per card at normal tempo).
 */
export const TEMPO_MS = {
    relaxed: { playMs: 60_000, bidMs: 75_000 },
    normal: { playMs: 30_000, bidMs: 40_000 },
    fast: { playMs: 15_000, bidMs: 25_000 },
};
/** A finished trick rests on the table this long so everyone sees the last card. */
export const TRICK_PAUSE_MS = 1_200;
/** Breath between two hands. */
export const HAND_BREAK_MS = 3_000;
/** A human's move budget; table overrides win over engine constants. */
export function turnMsFor(tempo, phase, tempoMs) {
    const row = TEMPO_MS[tempo];
    return phase === "bidding" || phase === "trump"
        ? (tempoMs?.bidMs ?? row.bidMs)
        : (tempoMs?.playMs ?? row.playMs);
}
/** Where a bot hesitates: a single legal card needs no thought, opening a trick does. */
export function botPauseFor(state, seat) {
    if (state.phase === "bidding") {
        const { min: lowest } = getValidBids(state);
        // Once the bid is high, passing is not a decision anymore.
        return lowest >= 7
            ? { min: 600, max: 1_400, canPonder: false }
            : { min: 1_100, max: 2_800, canPonder: true };
    }
    if (state.phase === "trump")
        return { min: 1_200, max: 2_600, canPonder: true };
    const options = getValidCards(state, seat).length;
    if (options <= 1)
        return { min: 400, max: 900, canPonder: false };
    if (state.trick.plays.length === 0)
        return { min: 1_000, max: 2_400, canPonder: true };
    return { min: 700, max: 1_600, canPonder: options > 3 };
}
//# sourceMappingURL=tempo.js.map